<template>
  <modal v-if="modalStateFor(modalId).isVisible" :state="modalStateFor(modalId)" @toggle-modal="reset">
    <div slot="body">
      <h3 class="modal-title">Experimental Features</h3>

      <scroll-area class="max">
        <matrix
          fetching-message="No experimental features found"
          class="clear-table"
          :has-header="false"
          :has-data="Object.keys(features).length !== 0">
          <template slot="table-body">
            <template v-for="(feature, featureId) in features">
              <t-row :key="featureId" class="col-md-3 align-items-baseline">
                <t-prefix>
                  <input
                    type="checkbox"
                    :name="id(featureId)"
                    :id="id(featureId)"
                    v-model="feature[nodeEnv]"
                  >
                </t-prefix>
                <t-column class="row-title">
                  <label :for="id(featureId)">
                    {{feature.name}}
                  </label>
                  <p class="collapse" :id="`${id(featureId)}-description`">
                    {{feature.description}}
                  </p>
                </t-column>
                <t-suffix>
                    <span v-if="feature.description" class="cta-container">
                    <button
                      type="button"
                      class="btn-icon clear-area show-tags collapsed"
                      data-toggle="collapse"
                      :data-target="`#${id(featureId)}-description`"
                      aria-expanded="false">
                      <icon class="arrow-chevron"></icon>
                      <span class="sr-only">{{feature.name}} Description</span>
                    </button>
                  </span>
                </t-suffix>
              </t-row>
            </template>
          </template>
        </matrix>
      </scroll-area>

      <hr>

      <div class="cta">
        <button @click.prevent="reset" class="btn block red outline">Cancel</button>
        <button type="button" @click="save" class="btn block green">Done</button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue"
  import {ModalID} from "~/enums/modalID";
  import {IModalState} from "~/interfaces/modalInterfaces";
  import {BooleanHelper} from "~/helpers/booleanHelper";
  import {StringHelper} from "~/helpers/stringHelper";
  import modalController from "~/mixins/modalController"
  import AppConfig from "~/appConfig";

  export default Vue.extend({
    name: "features",
    mixins: [
      modalController,
    ],
    data: function() {
      return {
        features: {},
        nodeEnv: new AppConfig().mode,
      }
    },
    created() {
      this.restore()
    },
    computed: {
      modalId(): ModalID {
        return ModalID.features
      },
      modalState(): IModalState {
        return this.modalStateFor(this.modalId)
      },
    },
    methods: {
      id(featureId: string) {
        return `feature-${StringHelper.toDash(featureId)}`
      },
      toggleModal() {
        this.showModal(this.modalId, BooleanHelper.toggle(this.modalState.isVisible))
      },
      reset() {
        this.restore()
        this.toggleModal()
      },
      save() {
        this.$feature.set(this.features).save()
        this.toggleModal()
      },
      restore() {
        this.features = this.$feature.copy()
      },
    },
  })
</script>
